export const PREMIUM_LINE_BLUE_COLOR = '#5199c6'
export const PREMIUM_LINE_GOLD_COLOR = '#f4b91f'
export const PREMIUM_LINE_GREEN_COLOR = '#68e756'
export const PREMIUM_LINE_PURPLE_COLOR = '#5199c6'
